import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    fetchCalendars(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('calendars', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchCalendar(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`calendars/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addCalendar(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.post('calendars', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    editCalendar(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`calendars/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteCalendar(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`calendars/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
